// Centralized role-based capability checks. Backend is the source of truth
// (RBAC engine + middleware); these helpers exist only to gate UI controls
// so users don't see buttons that 403 on click.

const PRIVILEGED = new Set(['owner', 'admin']);

export function canManageMembers(role) {
  return PRIVILEGED.has(role);
}

export function isPrivileged(role) {
  return PRIVILEGED.has(role);
}

export function canAuthorHiddenSnippets(role) {
  return PRIVILEGED.has(role);
}
